import { getData, postData, putData } from '../services/apiService';
import { Host } from '../types/Host';
import { UserRole, UserRoleHostOrg } from '../types/UserRole';

export const getHosts = async () : Promise<Host[]> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData('/hosts', {limit : 10});
      return response.data as Host[];
    } catch (error) {
      console.error('Failed to fetch hosts:', error);
    }
    return [];
  };

  export const getHostById = async (hostId: string): Promise<Host | null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await getData(`/hosts/${hostId}`, {});
      return response.data as Host;
    } catch (error) {
      console.error('Failed to fetch hosts:', error);
    }
    return null
  };
  

  export const createHost = async (host: Host): Promise<{ host: Host, userRole: UserRole }| null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await postData(`/hosts`, host );
      return {host: response.data.host as Host, userRole: response.data.role as UserRole };
    } catch (error) {
      console.error('Failed to create hosts:', error);
      throw error;
    }
  };
  

  export const updateHost = async (host_id: string, host: Host): Promise<Host | null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await putData(`/hosts/${host_id}`, host );
      return response.data as Host;
    } catch (error) {
      console.error('Failed to create hosts:', error);
      throw error;
    }
  };

  export const getRolesForHost = async (host_id: string): Promise<UserRoleHostOrg[]> => {
    try {
      const response = await getData(`/hosts/${host_id}/roles`, {});
      return response.data as UserRoleHostOrg[];
    } catch (error) {
      console.error('Failed to fetch hosts:', error);
    }
    return []
  };